import React from "react"
import Helmet from "react-helmet"

import { instantGiftData } from "areas/instant-gift/explained/data"
import ImageBackgroundBanner from "components/landing/image-background-banner"

const MainBanner = () => (
  <div>
    <Helmet>
      <title>Gift Preview Video</title>
    </Helmet>
    <ImageBackgroundBanner element={instantGiftData()} firstElement />
  </div>
)

export default MainBanner
